import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { format } from "date-fns";
import { enGB, fr } from "date-fns/locale";

import translationEN from "../i18n/en.json";
import translationAR from "../i18n/ar.json";
import translationBN from "../i18n/bn.json";
import { DEFAULT_LANGUAGE } from "../constants";

const resources = {
  en: {
    translation: translationEN
  },
  ar: {
    translation: translationAR
  },
  bn: {
    translation: translationBN
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: "defaultDetector",
  lookup() {
    if (DEFAULT_LANGUAGE) {
      return DEFAULT_LANGUAGE;
    }
    return null;
  }
});

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    detection: {
      // order and from where user language should be detected
      order: ["querystring", "cookie", "localStorage", "defaultDetector", "navigator"],
      // keys or params to lookup language from
      lookupQuerystring: "lng",
      lookupCookie: "lng",
      lookupLocalStorage: "lng",
      caches: ["localStorage", "cookie"],
      cookieMinutes: 60 * 24 * 30,
      // only detect languages that are in the whitelist
      checkWhitelist: true
    },
    fallbackLng: DEFAULT_LANGUAGE || "en",
    resources,
    debug: false,
    keySeparator: ".",
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
      format: (value, formatStr, lng) => {
        if (value instanceof Date) {
          const locale = lng === "fr" ? fr : enGB;
          return format(value, formatStr, { locale });
        }

        if (!Number.isNaN(parseFloat(value)) && Number.isFinite(value)) {
          const locale = lng === "fr" ? "fr-FR" : "en-GB";
          return Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(value);
        }
        return value;
      }
    }
  });

export default i18n;
